<template>
    <div class="">
        <div>
            <div>
                <div>
                    <div>
                        <h3>Asignaciones administrativas</h3>
                    </div>
                </div>
                <div>
                    <div></div>
                </div>
            </div>
        </div>
        <div>

        </div>
    </div>
</template>

<script>
export default {
    beforeMount() {
        this.$root.$emit('changeModel', this.$route.name)
    }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Modelos/Nomina.vue